import { IShortcut } from 'schemas';

export const getIndex = (id: number, items: IShortcut[]): number =>
  items.findIndex((item) => item.id === id);
